import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
import { Button } from "@mui/material";

import { getCategories, getCategoriesV2 } from "services/categoryServices";
import AddAddOnCategoryDialog from "./_addAddOnCategoryDialog";
import { currencyFormat } from "helper/NumberFormat";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";
const initFilter = {
  name: '',
  load: true,
  page: 0,
  limit: 20
}

export default function AddOnCategoryComponent({
    merchantId, placeId
}) {
    const [isLoading, setLoading] = useState(true)
    const [filter, setFilter] = useState(initFilter)
    const [totalData, setTotalData] = useState(0)

    const [rows, setRows] = useState([]);
    const [dialog, setDialog] = useState({
        open: false,
        data: null,
    });

    const loadData = async () => {
        try {
            let { data, error } = await getCategoriesV2({
                merchantId: merchantId || '',
                placeId: placeId || '',
                name: filter.name,
                page: filter.page,
                limit: filter.limit
            });
            if (error) throw error;
            if (data) {
                setRows(data.items);
                setLoading(false)
                setTotalData(data.totalData)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    useEffect(() => {
        loadData();
    }, [filter.page]);

    const valueCustomator = (row) => {
        return ({
          name: <span className='span-link' onClick={() => { setDialog({ open: true, data: row }) }}>{row.name}</span>,
          defaultPrice: <TCLabel>{currencyFormat(row.defaultPrice)}</TCLabel>,
        })
    }

    const onChangePage = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }));
    }
    
    return (
        <>
        <Button variant="contained" color="primary" sx={{mb: 2}} onClick={() => {
            setDialog({ open: true });
        }}>Add Addon Category</Button>
        <TableComponent
            columns={[
                { label: "Name" },
                { label: "Default Price" },
            ]}
            rows={rows}
            valueCustomator={valueCustomator}
            pageChange={(e) => {
                onChangePage({page: e})
            }}
            loading={isLoading}
            totalData={totalData}
            page={filter.page}
        />
        <AddAddOnCategoryDialog merchantId={merchantId} placeId={placeId} setDialog={dialog} handleClose={() => {
            setDialog({
                open: false,
                data: null,
            });
            loadData();
        }}/>
        </>
    );
}
